<template>
  <v-card flat class="list-content">
    <v-toolbar flat color="white">
      <v-text-field
        flat
        solo
        prepend-icon="search"
        placeholder="Type something"
        v-model="search"
        hide-details
        class="hidden-sm-and-down"
      ></v-text-field>
      <v-btn icon>
        <v-icon>filter_list</v-icon>
      </v-btn>
      <v-btn v-if="loanData.title === 'workbench'" style="background: #03a9f4; color: #fff; box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2);" @click="getFile">
        get operated loans
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="loanData.headers"
        :search="search"
        :items="loanData.items"
        :footer-props.prop="rowsPerPageItems"
        :options.sync="pagination"
        class="elevation-1"
        item-key="name"
      >
        <template v-slot:item="props">
          <tr>
            <td>
              <v-tooltip bottom v-if="showButton(props.item)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    depressed
                    icon
                    fab
                    dark
                    :color="iconColor(props.item)"
                    small
                    @click="gotoPage(props.item.id, props.item)"
                  >
                    <v-icon>read_more</v-icon>
                  </v-btn>
                </template>
                <span>{{ getToolTip(props.item) }}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="showCopyLoan(props.item)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    fab
                    small
                    color="primary"
                    class="action-button"
                    @click="copyLoan(props.item)"
                    slot="activator"
                    v-bind="attrs"
                    v-on="on">
                    <v-icon>content_copy</v-icon>
                  </v-btn>
                </template>
                <span>Copy Loan</span>
              </v-tooltip>
            </td>
            <td
              :key="headerData.value"
              :title="assist.tool.adapterValue(headerData.value, props.item[headerData.value])"
              v-for="headerData in loanData.headers.filter(
              (val, index, arr) => {
                return index !== 0;
              }
            )"
            >
              <template v-if="headerData.value !== 'fullName'">
                {{ assist.tool.adapterValue(headerData.value, props.item[headerData.value]) }}
              </template>
              <template v-else>
                {{ assist.tool.spliceFullName(props.item.firstName, props.item.middleName, props.item.lastName) }}
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
    <copy-loan
      v-model="layouts.dialogs.copyLoan.display"
      :loan="layouts.dialogs.copyLoan.json"
      @hideDialog="hideDialog"
    ></copy-loan>
  </v-card>
</template>

<script>
import { LoanOperationApi } from '@/api/pandaria'
import '@/setting/render-filter-setting'
import { Tool, Crypto, DataType, Popup, Cache, Authentication } from '@/util/index'
import CopyLoan from '@/components/panda/common/detail/CopyLoan'

const tool = new Tool()
const popup = new Popup()
const cache = new Cache()

export default {
  name: 'arb-loan-list',
  inject: ['reload'],
  components: {
    CopyLoan
  },
  props: {
    loanData: {
      type: Object,
      default: function () {
        return {}
      },
      items: []
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      assist: {
        tool: tool,
        dataType: DataType
      },
      search: '',
      pagination: {
        page: 1,
        rowsPerPage: 5,
        totalDesserts: 0
      },
      rowsPerPageItems: [5, 10, 25, 50, { text: 'All', value: -1 }],
      loanPhaseEnum: DataType.LoanPhaseEnum,
      loanStatusEnum: DataType.LoanStatus,
      layouts: {
        dialogs: {
          copyLoan: {
            display: false,
            json: {}
          }
        }
      }
    }
  },
  computed: {
    loanList () {
      return this.loanData.items
    }
  },
  watch: {
    pagination (newValue) {
      this.$emit('setPagenation', newValue)
    },
    loanList (val) {
      this.$forceUpdate()
    },
    title: {
      handler: function (val) {
        console.log(val)
      }
    }
  },
  methods: {
    showCopyLoan (item) {
      const authorization = this.store.getters.getAuthorization
      const withdrawLoanStatus = [
        DataType.LoanStatus.NEGATIVE_WITHDRAWN.value,
        DataType.LoanStatus.POSITIVE_WITHDRAWN.value,
        DataType.LoanStatus.GOOD_STANDING.value,
        DataType.LoanStatus.WARNING.value,
        DataType.LoanStatus.GOOD_STANDING_PAID_OFF.value,
        DataType.LoanStatus.WARNING_PAID_OFF.value,
        DataType.LoanStatus.TRANSFERRED_PENDING_PAID_OFF.value,
        DataType.LoanStatus.TRANSFERRED_PAID_OFF.value,
        DataType.LoanStatus.PAID_OFF.value,
        DataType.LoanStatus.PENDING_TRANSFERRED_PAID_OFF.value,
        DataType.LoanStatus.NEW_PAID_OFF.value,
        DataType.LoanStatus.IN_HOUSE_REPLAN_PAID_OFF.value,
        DataType.LoanStatus.IN_HOUSE_SETTLEMENT_PAID_OFF.value,
        DataType.LoanStatus.OUT_HOUSE_PAID_OFF.value,
        DataType.LoanStatus.IN_HOUSE_PAID_OFF_SETTLEMENT_QUEUE.value,
        DataType.LoanStatus.IN_HOUSE_PAID_OFF_SETTLEMENT.value
      ]
      if (item.portfolioId === 8) {
        return Authentication.matchElementPrivilege(authorization.privileges, DataType.PrivilegeCode.EXPRESS_LOAN, DataType.PrivilegeType.EXECUTABLE) &&
            tool.isNotEmpty(item) && (withdrawLoanStatus.includes(item.slaveLoanStatus) || withdrawLoanStatus.includes(item.loanStatus))
      } else {
        return Authentication.matchElementPrivilege(authorization.privileges, DataType.PrivilegeCode.EXPRESS_LOAN, DataType.PrivilegeType.EXECUTABLE) &&
            tool.isNotEmpty(item) && withdrawLoanStatus.includes(item.loanStatus)
      }
    },
    getToolTip (item) {
      return (DataType.LoanSourceEnum.VERTICAL.value & item.source) === DataType.LoanSourceEnum.VERTICAL.value
        ? 'Manually Create Lead'
        : 'Go To Detail'
    },
    copyLoan (item) {
      this.layouts.dialogs.copyLoan.json = item
      this.layouts.dialogs.copyLoan.display = true
    },
    iconColor (item) {
      return (DataType.LoanSourceEnum.VERTICAL.value & item.source) === DataType.LoanSourceEnum.VERTICAL.value
        ? 'error'
        : 'primary'
    },
    showButton (data) {
      if ((DataType.LoanSourceEnum.VERTICAL.value & data.source) === DataType.LoanSourceEnum.VERTICAL.value) {
        const authorization = this.store.getters.getAuthorization
        if (!Authentication.matchElementPrivilege(authorization.privileges, DataType.PrivilegeCode.MANUALLY_CREATE_LEAD, DataType.PrivilegeType.EXECUTABLE)) {
          return false
        }

        const portfolioId = data.portfolioId
        const portfolioArray = this.store.getters.getRuntimePortfolioArray
        let currentPortfolioJson
        for (const portfolioJson of portfolioArray) {
          if (portfolioJson.portfolioId === portfolioId) {
            currentPortfolioJson = portfolioJson
          }
        }

        return tool.isNotEmpty(currentPortfolioJson) && currentPortfolioJson.manualCreateLead === '1' &&
          (DataType.LoanStatus.GOOD_STANDING_PAID_OFF.value === data.loanStatus ||
            DataType.LoanStatus.PAID_OFF.value === data.loanStatus ||
            DataType.LoanStatus.WARNING_PAID_OFF.value === data.loanStatus)
      } else {
        return true
      }
    },
    gotoPage (id, data) {
      const $this = this
      if (data.action !== 'trackerList') {
        if ((DataType.LoanSourceEnum.VERTICAL.value & data.source) === DataType.LoanSourceEnum.VERTICAL.value) {
          const portfolioId = data.portfolioId
          const portfolioArray = this.store.getters.getRuntimePortfolioArray
          let currentPortfolioJson
          for (const portfolioJson of portfolioArray) {
            if (portfolioJson.portfolioId === portfolioId) {
              currentPortfolioJson = portfolioJson
            }
          }
          if (tool.isNotEmpty(currentPortfolioJson) && currentPortfolioJson.manualCreateLead === '1' &&
            (DataType.LoanStatus.GOOD_STANDING_PAID_OFF.value === data.loanStatus ||
              DataType.LoanStatus.PAID_OFF.value === data.loanStatus ||
              DataType.LoanStatus.WARNING_PAID_OFF.value === data.loanStatus)) {
            const requestData = {
              email: data.email,
              ssn: data.ssn,
              phone: data.homePhone,
              accountNo: data.accountNo,
              portfolioList: [currentPortfolioJson.portfolioId]
            }
            LoanOperationApi.customerSearch(requestData, function (result) {
              let isGotoPage = true
              for (const item of result) {
                if ((tool.isNotEmpty(item.phase) && item.phase !== DataType.LoanPhaseEnum.TERMINATED.value) ||
                  (tool.isNotEmpty(item.status) && !item.status.toString().startsWith('6'))) {
                  isGotoPage = false
                  break
                }
              }
              if (isGotoPage) {
                $this.$router.replace('/pre-origination/manually-create-lead')
                $this.$store.commit('setManualCreateLeadId', data.id)
              } else {
                popup.popupForWarning('There are active loans for current customer in ' + currentPortfolioJson.portfolioName)
              }
              $this.$emit('hideDialog')
            }, function (failure) {
              $this.$emit('hideDialog')
            })
          }
        } else {
          this.gotoDetail(id, data)
        }
      } else {
        $this.$store.commit('setLockReason', '')
        cache.setSessionLoanId(Crypto.encrypt(data.loanId))
        $this.$router.push('/pre-origination/application')
      }
    },
    gotoDetail (id, data) {
      let prefix = ''
      let phase = data.phase
      if (phase === DataType.LoanPhaseEnum.LOAN_ORIGINATION.value) {
        prefix = DataType.LoanPhaseEnum.LOAN_ORIGINATION.abbr
      } else {
        let flag = false
        let loanStatus = data.loanStatus
        if (tool.isNotEmpty(data.slaveLoanStatus)) {
          loanStatus = data.slaveLoanStatus
        }
        for (const item in this.loanStatusEnum) {
          const enumItem = this.loanStatusEnum[item]
          if (loanStatus === enumItem.value) {
            if (tool.isNotEmpty(enumItem.prefix)) {
              flag = true
              prefix = enumItem.prefix
            }
            break
          }
        }

        if (!flag) {
          if (tool.isNotEmpty(data.latestSlaveLoanPhase)) {
            phase = data.latestSlaveLoanPhase
          }
          for (const item in this.loanPhaseEnum) {
            if (phase === this.loanPhaseEnum[item].value) {
              prefix = this.loanPhaseEnum[item].abbr
            }
          }
        }
      }

      if (tool.isEmpty(prefix)) {
        popup.popupForWarning('Fail to go to detail')
      } else {
        if (prefix === DataType.LoanPhaseEnum.LOAN_ORIGINATION.abbr) {
          cache.setSessionLoanId(Crypto.encrypt(data.id))
          if (this.$route.path.includes('/pre-origination/application') && !this.$route.path.includes('/queue')) {
            this.reload()
          } else {
            this.$router.replace('/pre-origination/application')
          }
        } else {
          this.$router.push('/{0}/application/{1}'.format(prefix, Crypto.encrypt(data.id)))
        }
        this.$store.commit('setLockReason', DataType.LockLoanReasonEnum.CUSTOMER_SEARCH.value)
        this.$emit('hideDialog')
      }
    },
    hideDialog () {
      this.$emit('hideDialog')
    },
    getFile () {
      this.$parent.getTrackerList()
    }
  }
}
</script>
<style scoped>
  .v-icon {
    display: flex;
    flex: 1;
    justify-content: space-around;
  }
  .list-content td{
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
</style>
